import React from "react";

import PinLocate from '../img/bullet_location_a.png';
import Profile from '../img/adya.jpeg';
import ArrowBlue from '../img/arrow blue.png'

class Jobs extends React.Component {
  render() {
    return (
      <div class="container d-flex h-100">
        <div class="align-self-center w-100 row">
          <div class ="col-lg-5 col-md-6 offset-lg-3" style = {{textAlign: 'left'}}>
            <h1 class = 'jobs-moving-title jobs-heading-title'>Working in Oval</h1>
            <div class = 'jobs-content-container'>
              <div></div>
              <p class = 'jobs-paragraph'>
                <div style = {{height:'5px', width: '30px', backgroundColor:'#e0df87'}} />
                <h4 class = 'community-title-modifier article-title'>What They Said About Working at Oval Tech</h4>
                <img class = 'circled-image d-none d-sm-block' src = {Profile} width = '70px' />
                "Datang dari background startup, gue sempat khawatir tentang pindah ke suasana korporat. Tapi ternyata di sini suasananya fleksibel banget jadi seru dan nyaman banget nge-develop berbagai produk digital."<br/>

                <strong>Adya, 23  -  Product Manager</strong>
                <br/><br/>
                <strong>WORKING LOCATION</strong><br/>
                <div class = 'row' style = {{margin:'10px'}}>
                  <div class = 'col-xs-4'>
                    <img src = {PinLocate} width = '30px' />
                  </div>
                  <div class = 'col-xs-6'>
                    <p style = {{lineHeight: 1.3, marginBottom:0}}>
                      <span class = 'jobs-location-title'>Menara Kompas</span><br/>
                      <span class = 'jobs-location-subtitle'>Palmerah Selatan, Jakarta</span>
                    </p>
                  </div>
                </div>
              </p>
            </div>
          </div>
          <div class ="col-lg-4 col-md-6">
            <div class = 'jobs-table'>
              <ul class = 'jobs-table-list'>
              <strong>Openings</strong>
                <li>Engineering Manager</li>
                <li>Ass. Product Manager</li>
                <li>DevOps Engineer</li>
                <li>Software Engineer</li>
                <li>Mobile Engineer</li>
                <span style = {{textAlign: 'center', display:'block', fontSize:'0.8em', padding:'5px'}}>
                <a class= 'link-text' href ='https://careers.smartrecruiters.com/KGCF2' >DETAILS AND MORE JOBS   <img src = {ArrowBlue} width = '10px' /></a>
                </span>
              </ul>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/components/Jobs.js